module.exports = "https://product-cdn.sandbox.surfline.com/kbyg/_next/static/images/app-banner-phone-57aa58947cb5f10fcdb73175652e6652.png";